
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface RangeFiltersProps {
  availablePortions: number[];
  setAvailablePortions: (value: number[]) => void;
  deliveryOnly: boolean;
  setDeliveryOnly: (value: boolean) => void;
  rating: number[];
  setRating: (value: number[]) => void;
}

export const RangeFilters = ({
  availablePortions,
  setAvailablePortions,
  deliveryOnly,
  setDeliveryOnly,
  rating,
  setRating,
}: RangeFiltersProps) => {
  return (
    <>
      <div>
        <h3 className="text-sm font-medium mb-2">Available Portions (Min: {availablePortions})</h3>
        <Slider
          defaultValue={[1]}
          min={1}
          max={10}
          step={1}
          value={availablePortions}
          onValueChange={setAvailablePortions}
        />
      </div>

      <div className="flex items-center justify-between space-x-2">
        <Label htmlFor="delivery-toggle" className="text-sm font-medium">
          Available for delivery
        </Label>
        <Switch
          id="delivery-toggle"
          checked={deliveryOnly}
          onCheckedChange={setDeliveryOnly}
          className="data-[state=checked]:bg-primary"
        />
      </div>

      <div>
        <h3 className="text-sm font-medium mb-2">Rating ({rating}+ stars)</h3>
        <Slider
          defaultValue={[0]}
          max={5}
          min={0}
          step={0.5}
          value={rating}
          onValueChange={setRating}
        />
      </div>
    </>
  );
};
